export const experimentsConfig = {
    design_services_hub_page_design_live: {
        variations: ['control', 'variant_10_dollar', 'variant_19_dollar'],
    } as const,
    design_services_sdp_product_modeling_poc: {
        variations: ['control', 'test'],
    } as const,
    design_services_hub_page_recently_viewed_rec: {
        variations: ['control', 'test'],
    } as const,
} as const;
